var App = App || {};

App.Blog = (function ($) {
    'use strict';

    function Masonry() {

        const bpMasonry = ["xxl", "xl", "lg"];
        const bpCurrent = ZAGFramework.GetCurrentBP();
        const blog = $(".blog-main-posts-cards");

        if (bpMasonry.includes(bpCurrent)) { MasonryInit(); }
        $(document).bind("enter-lg enter-xl enter-xxl", function () { MasonryInit() });
        $(document).bind("enter-xs enter-sm enter-md", function () { MasonryDestroy() });

        function MasonryInit() {
            blog.masonry({
                itemSelector: ".blog-main-posts-cards-sizer",
                transitionDuration: '0.1s'
            });
        }

        function MasonryDestroy() {
            var msnry = blog.data('masonry');
            if (msnry !== undefined)
                blog.masonry("destroy");
        }
    }

    return {
        Masonry: Masonry
    };

})(jQuery);

$(function () {
    App.Blog.Masonry();
});